module.exports = __webpack_public_path__ + "static/media/DEJIBEB_patho.f4e9c5d0.png";